import React, { useCallback, useMemo, useState } from 'react';
import { View } from 'react-native';
import InteractivePieChart from 'design-system/InteractivePieChart';
import Text from 'design-system/Text';
import useSelectedCategory from 'features/analytics/hooks/useSelectedCategory';
import { runOnJS, useDerivedValue } from 'react-native-reanimated';
import { useColorOfCategory } from 'hooks/useCategory';
import Amount from 'design-system/Amount';
import BlurAmountView from 'design-system/BlurAmountView';
const CategoryPieChart = ({ currency, monthlyCategories, isInFocus, blurValue, }) => {
    const colorOfCategory = useColorOfCategory();
    const pieSlices = useMemo(() => {
        const monthlyCategoriesFrom = monthlyCategories?.categories.filter((mc) => !mc.parentCategoryId) || [];
        return monthlyCategoriesFrom.map((mc) => ({
            key: mc.id,
            value: mc.total > 0 ? 0 : Math.abs(mc.total),
            selectedColor: colorOfCategory(mc),
            category: mc,
            displayName: mc.displayName,
        }));
    }, [colorOfCategory, monthlyCategories?.categories]);
    const { selectedCategoryId, selectCategoryId } = useSelectedCategory();
    useDerivedValue(() => {
        if (!isInFocus.value)
            return;
        let reset = false;
        if (selectedCategoryId.value === undefined) {
            reset = true;
        }
        else {
            const curr = selectedCategoryId.value;
            if (pieSlices.find((slice) => slice.key === curr && slice.value > 0) ===
                undefined) {
                reset = true;
            }
        }
        if (reset) {
            const biggestSlice = pieSlices.reduce((previousValue, currentValue) => {
                if (!previousValue || currentValue.value > previousValue?.value) {
                    return currentValue;
                }
                return previousValue;
            }, undefined);
            if (biggestSlice && biggestSlice.value > 0) {
                runOnJS(selectCategoryId)(biggestSlice.key);
            }
        }
    }, [isInFocus, pieSlices, selectedCategoryId]);
    const [highlightedSlice, setHighlightedSlice] = useState(null);
    useDerivedValue(() => {
        const slice = pieSlices.find((slice) => slice.key === selectedCategoryId.value);
        if (slice && slice.value > 0) {
            runOnJS(setHighlightedSlice)(slice);
        }
        else {
            runOnJS(setHighlightedSlice)(null);
        }
    }, [pieSlices, selectedCategoryId]);
    const onSelectPieSlice = useCallback((pieSlice) => {
        selectCategoryId(pieSlice.key);
    }, [selectCategoryId]);
    return (<View>
      <InteractivePieChart pieSlices={pieSlices} onSelectPieSlice={onSelectPieSlice} selectedPieSliceKey={selectedCategoryId}>
        <BlurAmountView enabled={blurValue}>
          <Amount Numbers-24 value={{
            value: highlightedSlice?.value ?? 0,
            currency,
        }}/>
        </BlurAmountView>
        {highlightedSlice !== null && (<Text TextThin-14 Gray>
            {highlightedSlice.displayName}
          </Text>)}
      </InteractivePieChart>
    </View>);
};
export default React.memo(CategoryPieChart);
